import React from 'react'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import AsyncSelect from 'react-select/lib/Async'
import { Button } from '../../../styles/styled-elements'
import TextField from '@material-ui/core/TextField'
import FormHelperText from '@material-ui/core/FormHelperText'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper';
import SvgIcon from '@material-ui/core/SvgIcon';
import { emphasize } from '@material-ui/core/styles/colorManipulator'
import CheckCircle from '../../icons/CheckCircle'
import CircleOutline from '../../icons/CircleOutline'

const styles = theme => {
  return ({
    root: {
      flexGrow: 1,
      height: 250,
    },
    formContainer: {
      padding: 30,
    },
    input: {
      display: 'flex',
      padding: 0,
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center',
      overflow: 'hidden',
    },
    noOptionsMessage: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    },
    placeholder: {
      position: 'absolute',
      left: 2,
      fontSize: 16,
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: theme.spacing.unit,
      left: 0,
      right: 0,
    },
    formControl: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
    selectField: {
    },
    selectDropdownArrow: {
      color: theme.palette.text.secondary
    },
    formSectionHeading: {
      fontSize: 20,
      fontWeight: 500,
      marginTop: 18,
      marginBottom: 18,
    },
    inputRowGrid: {
      flexGrow: 1,
      width: '100%',
    },
    sensorsSelectHeading: {
      display: 'inline-flex',
      justifyContent: 'center',
      marginBottom: 10,
      textAlign: 'center'
    },
    sensorsSelectRowCell: {
      display: 'inline-flex',
      justifyContent: 'center',
    },
    graphSettingsUnitCell: {
      display: 'inline-flex',
      alignItems: 'center',
      fontWeight: 500,
      fontSize: '1.2em',
    },
    saveButtonContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: 40,
    }
  }
)}

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function IndicatorSeparator() {
  return null
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

function Control(props) {
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

function Option(props) {

  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  )
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );
}

function DropdownIndicator(props) {
  return <SvgIcon className={props.selectProps.classes.selectDropdownArrow}>
    <path d="M7 10l5 5 5-5z" />
  </SvgIcon>
}

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

const components = {
  Control,
  Menu,
  Option,
  Placeholder,
  NoOptionsMessage,
  IndicatorSeparator,
  DropdownIndicator,
  ValueContainer,
}


class DuplicateForm extends React.Component {

  formatCompanyItem = item => { return { value: item.id, label: `${item.name}` }}

  defaultCompanies = () => this.props.childCompanies.childCompanies
    .slice(0,10)
    .map(item => this.formatCompanyItem(item))

  loadCompanyOptions = (inputValue, callback) => {
    console.log('this.props.childCompanies',this.props.childCompanies)
    const options = this.props.childCompanies.childCompanies
    .filter(({name}) => name.toLowerCase().includes(inputValue.toLowerCase()))
    .slice(0,15)
    .map(item => this.formatCompanyItem(item))
    setTimeout(function () {
      callback(options)
    }, 500);
  }

  formatTimezoneItem = item => { return { value: item.id, label: `${item.name} (${item.utc_offset_label})` }}

  defaultTimezones = () => this.props.timezones.timezones
    .slice(0,15)
    .map(item => this.formatTimezoneItem(item))

  loadTimezoneOptions = (inputValue, callback) => {
    const options = this.props.timezones.timezones
    .filter(({name, utc_offset_label}) => name.toLowerCase().includes(inputValue.toLowerCase()) || utc_offset_label.toLowerCase().includes(inputValue.toLowerCase()))
    .slice(0,15)
    .map(item => this.formatTimezoneItem(item))
    setTimeout(function () {
      callback(options)
    }, 500);
  }

  formatSiteItem = item => { return { value: item.id, label: `${item.company_name}: ${item.name}`, company_slug: item.company_slug }}

  defaultSitesToDuplicate = () => this.props.sites.sites
    .map(item => this.formatSiteItem(item))
    .sort((a, b) =>  a.label.localeCompare(b.label))
    .slice(0,15)

  loadSiteToDuplicateOptions = (inputValue, callback) => {
    const options = this.props.sites.sites
    .filter(({name, company_name}) => name.toLowerCase().includes(inputValue.toLowerCase()) || company_name.toLowerCase().includes(inputValue.toLowerCase()))
    .map(item => this.formatSiteItem(item))
    .sort((a, b) =>  a.label.localeCompare(b.label))
    .slice(0,15)
    setTimeout(function () {
      callback(options)
    }, 500);
  }

  defaultTargetSites = () => this.props.sites.sites
    .map(item => this.formatSiteItem(item))
    .sort((a, b) =>  a.label.localeCompare(b.label))
    .slice(0,15)

  loadTargetSiteOptions = (inputValue, callback) => {
    const options = this.props.sites.sites
    .filter(({name, company_name}) => name.toLowerCase().includes(inputValue.toLowerCase()) || company_name.toLowerCase().includes(inputValue.toLowerCase()))
    .map(item => this.formatSiteItem(item))
    .sort((a, b) =>  a.label.localeCompare(b.label))
    .slice(0,15)
    setTimeout(function () {
      callback(options)
    }, 500);
  }

  formatDataLoggerDeviceItem = item => {
    console.log("XXX item",item)
    const radioInterfaceName = item.radio_interface_name
    const labelPrefix = `${radioInterfaceName.charAt(0).toUpperCase()}${radioInterfaceName.slice(1)}: `
    const labelSsuffix = item.site_name ? ` – Assigned to ${item.site_company_name}: ${item.site_name}` : ' – Unassigned'
    const label = `${labelPrefix} ${item.serial_no} ${labelSsuffix}`
    return { value: item.id, label: label }
  }

  defaultDataLoggerDevices = () => this.props.dataLoggerDevices.dataLoggerDevices
    .map(item => this.formatDataLoggerDeviceItem(item))
    .sort((a, b) =>  a.label.localeCompare(b.label))
    .slice(0,15)

  loadDataLoggerDeviceOptions = (inputValue, callback) => {
    const options = this.props.dataLoggerDevices.dataLoggerDevices
    .map(item => this.formatDataLoggerDeviceItem(item))
    .filter(({label}) => label.toLowerCase().includes(inputValue.toLowerCase()))
    .sort((a, b) =>  a.label.localeCompare(b.label))
    .slice(0,15)
    setTimeout(function () {
      callback(options)
    }, 500);
  }

  getSelectValue = (options,paramName,value,formatter) => {
    if (!value) return null
    const valueObject = options.find(item => item[paramName]==value)
    if (formatter) {
      return formatter(valueObject)
    } else {
      return valueObject
    }
  }

  renderBody = (props,state) => {

    const { classes, sites } = props
    const { site } = sites

    const selectStyles = {
      input: base => ({
        ...base,
        '& input': {
          font: 'inherit',
        },
      }),
    }

    return <Paper className={props.classes.formContainer}>
      <form onSubmit={props.handleSubmit}>
        <div className={props.classes.formSectionHeading}>Site Duplication Details</div>

        <FormControl fullWidth={true} className={props.classes.formControl} error={props.errors && props.errors.siteToDuplicateId && props.errors.siteToDuplicateId.length}>
          <AsyncSelect
            className={props.classes.selectField}
            error={props.errors && props.errors.siteToDuplicateId}
            inputProps={{
              name: 'siteId',
              id: 'select-site',
            }}
            textFieldProps={{
              label: 'Site to Duplicate',
              InputLabelProps: {
                shrink: true,
              },
            }}
            value={this.getSelectValue(props.sites.sites,'id',props.siteToDuplicateId,this.formatSiteItem)}
            loadOptions={this.loadSiteToDuplicateOptions}
            defaultOptions={this.defaultSitesToDuplicate()}
            classes={classes}
            styles={selectStyles}
            components={components}
            onChange={this.props.handleAutocompleteChange('siteToDuplicateId')}
          />
          <FormHelperText id="textinput-site-error">{props.errors && props.errors.siteToDuplicate}</FormHelperText>
        </FormControl>

        <FormControl fullWidth={true} className={props.classes.formControl} error={props.errors && props.errors.dataLoggerDevice && props.errors.dataLoggerDevice.length}>
          <AsyncSelect
            className={props.classes.selectField}
            error={props.errors && props.errors.dataLoggerDevice}
            inputProps={{
              name: 'dataLoggerDeviceId',
              id: 'select-data-logger-device',
            }}
            textFieldProps={{
              label: 'Data Logger Device to Use',
              InputLabelProps: {
                shrink: true,
              },
            }}
            value={this.getSelectValue(props.dataLoggerDevices.dataLoggerDevices,'id',props.dataLoggerDeviceId,this.formatDataLoggerDeviceItem)}
            loadOptions={this.loadDataLoggerDeviceOptions}
            defaultOptions={this.defaultDataLoggerDevices()}
            classes={classes}
            styles={selectStyles}
            components={components}
            onChange={this.props.handleAutocompleteChange('dataLoggerDeviceId')}
          />
          <FormHelperText id="textinput-dataloggerdevice-error">{props.errors && props.errors.dataLoggerDevice}</FormHelperText>
        </FormControl>

        <FormControl fullWidth={true} className={props.classes.formControl} error={props.errors && props.errors.targetCompanyId  && props.errors.targetCompanyId.length}>
          <AsyncSelect
            className={props.classes.selectField}
            error={props.errors && props.errors.targetCompanyId}
            inputProps={{
              name: 'targetCompanyId',
              id: 'select-company',
            }}
            textFieldProps={{
              label: 'Company for New/Changed Site',
              InputLabelProps: {
                shrink: true,
              },
            }}
            value={this.getSelectValue(props.childCompanies.childCompanies,'id',props.targetCompanyId,this.formatCompanyItem)}
            loadOptions={this.loadCompanyOptions}
            defaultOptions={this.defaultCompanies()}
            classes={classes}
            styles={selectStyles}
            components={components}
            onChange={this.props.handleAutocompleteChange('targetCompanyId')}
          />
          <FormHelperText id="textinput-company-error">{props.errors && props.errors.targetCompanyId}</FormHelperText>
        </FormControl>

        <FormControl fullWidth={true} className={props.classes.formControl} error={props.errors && props.errors.name && props.errors.name.length}>
          <TextField
            className={props.classes.textField}
            error={props.errors && props.errors.newSiteName}
            id="textinput-name"
            name="newSiteName"
            label="Site Name"
            InputLabelProps={{
              shrink: true,
            }}
            value={props.newSiteName}
            onChange={this.props.handleInputChange}
          />
          <FormHelperText id="textinput-name-error">{props.errors && props.errors.name}</FormHelperText>
        </FormControl>

        <FormControl fullWidth={true} className={props.classes.formControl} error={props.errors && props.errors.targetSite && props.errors.targetSite.length}>
          <AsyncSelect
            className={props.classes.selectField}
            error={props.errors && props.errors.targetSite}
            inputProps={{
              name: 'targetSiteId',
              id: 'select-target-site',
            }}
            textFieldProps={{
              label: 'Target Site',
              InputLabelProps: {
                shrink: true,
              },
            }}
            value={this.getSelectValue(props.sites.sites,'id',props.targetSiteId,this.formatSiteItem)}
            loadOptions={this.loadTargetSiteOptions}
            defaultOptions={this.defaultTargetSites()}
            classes={classes}
            styles={selectStyles}
            components={components}
            onChange={this.props.handleAutocompleteChange('targetSiteId')}
          />
          <FormHelperText id="textinput-target-site-error">{props.errors && props.errors.targetSite}</FormHelperText>
        </FormControl>

        <FormControl fullWidth={true} className={props.classes.formControl} error={props.errors && props.errors.timezoneId && props.errors.timezoneId.length}>
          <AsyncSelect
            className={props.classes.selectField}
            error={props.errors && props.errors.timezoneId}
            inputProps={{
              name: 'timezoneId',
              id: 'select-timezone',
            }}
            textFieldProps={{
              label: 'Site Timezone',
              InputLabelProps: {
                shrink: true,
              },
            }}
            value={this.getSelectValue(props.timezones.timezones,'id',props.timezoneId,this.formatTimezoneItem)}
            loadOptions={this.loadTimezoneOptions}
            defaultOptions={this.defaultTimezones()}
            classes={classes}
            styles={selectStyles}
            components={components}
            onChange={this.props.handleAutocompleteChange('timezoneId')}
          />
          <FormHelperText id="textinput-timezone-error">{props.errors && props.errors.timezoneId}</FormHelperText>
        </FormControl>

        <Grid container>
          {props.errors && props.errors && Object.keys(props.errors).map((error) => <div><FormHelperText error>{props.errors[error]}</FormHelperText></div>)}
        </Grid>
        <Grid container className={classes.saveButtonContainer}>
          <Button variant="contained" size="medium" color="primary" className={classes.button}>
            Duplicate Site
          </Button>
        </Grid>
      </form>
    </Paper>
  }

  render() {
    console.log('this.state',this.state)
    console.log('this.props',this.props)
    return this.renderBody(this.props,this.state)
  }
}

export default withStyles(styles)(DuplicateForm)



// WEBPACK FOOTER //
// ./src/components/management/sites/DuplicateForm.js